import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { getInlineLoader, setCookie } from "../Helpers";
import {
	STR_BULK_SMS,
	STR_BULK_WHATSAPP,
	STR_CHANGE_PHONE_NUMBER,
	STR_CLIENTS,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_EFILING,
	STR_LOGOUT,
	STR_MAIN_MENU,
	STR_MY_COACH,
	STR_MY_STUDENTS,
	STR_NON_STOCK_ITEMS,
	STR_PAYMENT_SETTINGS,
	STR_PAYROLL,
	STR_PERSONAL_SETTINGS,
	STR_PURCHASES,
	STR_SALES,
	STR_SET_CURRENCY,
	STR_STOCK,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_USER_REPORT,
	STR_VENDORS,
	STR_WHATSAPP_SETUP
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdAnalytics, MdContactPage, MdInfoOutline, MdLogout, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdPerson, MdSupportAgent, MdTranslate, MdWhatsapp } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import { GrCurrency } from "react-icons/gr";
import { GiTeacher } from "react-icons/gi";
import sales_icon from '../assets/sales_icon.png'
import purchases_icon from '../assets/purchases_icon.png'
import payroll_icon from '../assets/payroll_icon.png';
import stock_icon from '../assets/stock_icon.png';
import clients_icon from '../assets/clients_icon.png';
import efiling_icon from '../assets/efiling_icon.png';
import whatsapp_icon from '../assets/whatsapp_icon.png';
import sms_icon from '../assets/sms_icon.png'

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		/*
		await Promise.all([
			
		])
		*/
		setReady(true);
	}


	useEffect(() => {
		init();
	}, [])



	if (ready) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingTop: "20px",
				}}
				className="mNoScrollBar"
			>
				<div className="container">

					<div className="row">

						<div className="col-md-12">
							<h6 className="main-section-title">
								{STR_MAIN_MENU[appContext.language]}
							</h6>
						</div>
						
						<div className="col-12 col-md-6">
							<div 
								className="main-menu-item text-center"
								onClick={() => {
									appContext.navTo({
										item: 'sales'
									})
								}}
							>
								<img
									className="mIcon"
									src={sales_icon}
								/>
								<h6 className="mTitle">{STR_SALES[appContext.language]}</h6>
							</div>
						</div>

            {/*			
						<div className="col-12 col-md-6">
							<div 
								className="main-menu-item text-center"
								onClick={() => {
									appContext.navTo({
										item: 'purchases'
									})
								}}
							>
								<img
									className="mIcon"
									src={purchases_icon}
								/>
								<h6 className="mTitle">{STR_PURCHASES[appContext.language]}</h6>
							</div>
						</div>
            */}

            {/*
						<div className="col-12 col-md-6">
							<div 
								className="main-menu-item text-center"
								onClick={() => {
									appContext.navTo({
										item: 'payroll'
									})
								}}
							>
								<img
									className="mIcon"
									src={payroll_icon}
								/>
								<h6 className="mTitle">{STR_PAYROLL[appContext.language]}</h6>
							</div>
						</div>
            */}

						<div className="col-12 col-md-6">
							<div 
								className="main-menu-item text-center"
								onClick={() => {
									appContext.navTo({
										item: 'stock-items'
									})
								}}
							>
								<img
									className="mIcon"
									src={stock_icon}
								/>
								<h6 className="mTitle">{STR_STOCK[appContext.language]}</h6>
							</div>
						</div>

            
						<div className="col-12 col-md-6">
							<div 
								className="main-menu-item text-center"
								onClick={() => {
									appContext.navTo({
										item: 'non-stock-items'
									})
								}}
							>
								<img
									className="mIcon"
									src={stock_icon}
								/>
								<h6 className="mTitle">{STR_NON_STOCK_ITEMS[appContext.language]}</h6>
							</div>
						</div>

						<div className="col-12 col-md-6">
							<div 
								className="main-menu-item text-center"
								onClick={() => {
									appContext.navTo({
										item: 'clients'
									})
								}}
							>
								<img
									className="mIcon"
									src={clients_icon}
								/>
								<h6 className="mTitle">{STR_CLIENTS[appContext.language]}</h6>
							</div>
						</div>

            {/*
						<div className="col-12 col-md-6">
							<div 
								className="main-menu-item text-center"
								onClick={() => {
									appContext.navTo({
										item: 'vendors'
									})
								}}
							>
								<img
									className="mIcon"
									src={clients_icon}
								/>
								<h6 className="mTitle">{STR_VENDORS[appContext.language]}</h6>
							</div>
						</div>
            

						<div className="col-12 col-md-6">
							<div 
								className="main-menu-item text-center"
								onClick={() => {
									appContext.navTo({
										item: 'efiling'
									})
								}}
							>
								<img
									className="mIcon"
									src={efiling_icon}
								/>
								<h6 className="mTitle">{STR_EFILING[appContext.language]}</h6>
							</div>
						</div>
            

						<div className="col-12 col-md-6">
							<div 
								className="main-menu-item text-center"
								onClick={() => {
									appContext.navTo({
										item: 'whatsapp'
									})
								}}
							>
								<img
									className="mIcon"
									src={whatsapp_icon}
								/>
								<h6 className="mTitle">{STR_BULK_WHATSAPP[appContext.language]}</h6>
							</div>
						</div>

						<div className="col-12 col-md-6">
							<div 
								className="main-menu-item text-center"
								onClick={() => {
									appContext.navTo({
										item: 'sms'
									})
								}}
							>
								<img
									className="mIcon"
									src={sms_icon}
								/>
								<h6 className="mTitle">{STR_BULK_SMS[appContext.language]}</h6>
							</div>
						</div>
            */}
						

					</div>

				</div>


			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}